import { render } from "./AppHeader.vue?vue&type=template&id=3d6e9a5c&ts=true"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/home/simon/projects/farmlink-poly/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__